// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../../types';
import media from '../../../../helpers/media';
import { SEMIBOLD } from '../../../../helpers/fontWeight';

export const GroupItemCount = styled<any, Theme>('span')`
  display: none;

  ${media.lg(css`
    display: initial;
  `)}
`;

export const GroupTitleStyled = styled<any, Theme>('dt')`
  color: ${props => props.theme.cart.titleColor};
  display: flex;
  font-size: ${props => props.theme.cart.fontSize};
  font-weight: ${SEMIBOLD};
  justify-content: space-between;
  line-height: 2;
  padding-top: .75rem;
  position: relative;

  ${media.lg(css`
    border-top: 1px solid ${props => props.theme.cart.borderColor};
    padding-right: 2rem;
  `)};
`;

type Props = {
  isOpen: boolean,
};

export const ClickPad = styled<any, Theme, Props>('div')`
  display: none;
  ${media.lg(css`
    bottom: 0;
    display: block;
    left: 0;
    opacity: .7;
    position: absolute;
    right: 0;
    top: 0;

    &::after {
      border-color: ${props => props.theme.cart.borderColor};
      border-style: solid;
      border-width: 0 0 2px 2px;
      content: '';
      display: block;
      height: .5rem;
      width: .5rem;
      position: absolute;
      top: ${props => (props.isOpen ? '1.65rem' : '1.25rem')};
      right: .2rem;
      transform: ${props => (props.isOpen ? 'rotateZ(135deg)' : 'rotateZ(-45deg)')};
    }
  `)};
`;

export default null;
